import { render, staticRenderFns } from "./AuthWithSocial.vue?vue&type=template&id=68cb13fc&scoped=true&"
import script from "./AuthWithSocial.vue?vue&type=script&lang=ts&"
export * from "./AuthWithSocial.vue?vue&type=script&lang=ts&"
import style0 from "./AuthWithSocial.vue?vue&type=style&index=0&id=68cb13fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cb13fc",
  null
  
)

export default component.exports